import React, { useState } from 'react';
import { Field } from 'formik';
import * as moment from 'moment';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import TextArea from 'web/components/form-elements/TextArea';
import UploadSpecification from 'web/components/UploadSpecification';
import RadioButton from 'web/components/form-elements/RadioButton';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

import NumberInput from 'web/components/form-elements/NumberInput';

import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import styled from 'styled-components'
import styles from '../claimRaiseModal.module.scss';

export default ({ response, props, setFieldValue, imageLoadCallBack, callBackFun }) => {
  const patternArr = [
    {
      value: 'QUALITY',
      label: 'Quality Issue',
    },
    {
      value: 'QUANTITY',
      label: 'Quantity Issue',
    }, {
      value: 'BOTH',
      label: 'Both Quantity & Quality',
    },
    {
      value: 'BOL',
      label: 'Incorrect/Incomplete BOL/POD',
    },
  ];
  // const [uploadSpecificationArr, setUploadSpecificationArr] = useState();

  const [otherState, setOtherState] = useState(false);

  const [conditionalState, setConditionalState] = useState('QUALITY');
  let typeOfIssueArr = [
    'Exposed Nails', 'Broken Boards', 'Missing Boards', 'Other'
  ]

  // used to find whether claim is resolved with exchange by seller so that we could show exchange related details
  let resolvedWithExchange = false;
  let exchangeClaimList = [];
  let exchangeClaimListTotalQuantity = 0
  if (response && response.order && response.order.claimDetails && response.order.claimDetails.length > 0) {
    exchangeClaimList = response.order.claimDetails.filter(
      (val) =>
        val.returnInstruction &&
        (val.returnInstruction.includes("Exchange") ||
          val.returnInstruction.includes("Redeliver"))
    );
    if (exchangeClaimList.length > 0) {
      resolvedWithExchange = true
      exchangeClaimListTotalQuantity = (exchangeClaimList[exchangeClaimList.length - 1].claimQuality && exchangeClaimList[exchangeClaimList.length - 1].claimQuality) + (exchangeClaimListTotalQuantity + exchangeClaimList[exchangeClaimList.length - 1].claimQuantity)
    }
  }

  const getMaterialDetails = (response) => {
    const orderDetails = response?.order?.orderDetails;
    const dim = orderDetails?.dimension;
    const commodityName = response?.commodity?.commodityName;
    const gradeName = response?.grade?.gradeName;
    const sizeWiseGrad = response?.grade?.sizeWiseGrad;
    const dimensions = (dim?.length && dim?.width && dim?.height) ? `${dim.length}x${dim.width}x${dim.height}` : '';
    const isHT = orderDetails?.isHeatTreared ? 'HT' : '';

    const parts = (orderDetails?.material === 'OTHER' || orderDetails?.material === 'PLASTIC')
      ? [dimensions].filter(Boolean)
      : [commodityName, gradeName, dimensions, sizeWiseGrad, isHT].filter(Boolean);

    return parts.join(', ');
  };

  let fileArr = []
  const qualityIssue = (radioType) => {
    return (
      <div className="">
        <RowGroup>
          <div className="row mx-0 marginBottom">
            <div className="col-12 flxWrapper marginBottom">
              <div className="my-2" style={{ maxWidth: "350px", flex: "1" }}>
                <p className="bold">
                  Total Number of Pallets with Quality Issues
                  <span className="star">*</span>
                </p>
              </div>
              <div className="TNP">
                <NumberInput
                  name="totalNumberQuality"
                  maxLength={4}
                  placeholder=""
                  quantityVal={520}
                />
              </div>
            </div>

            {radioType === "BOTH" && (
              <div className="col-12 flxWrapper">
                <div className="my-2">
                  <p className="bold">
                    Total Pallets Missing From Order
                    <span className="star">*</span>
                  </p>
                </div>
                <div className="TNP">
                  <NumberInput name="totalNumberQuantity" quantityVal={520} maxLength={4} placeholder="" />
                </div>
              </div>
            )}
          </div>
        </RowGroup>
        <RowGroup>
          <div className="row mx-0">
            <div className="col-12">
              <div className="mb-2">
                <p className="bold">Types of Quality Issues</p>
              </div>
              <div className="checkbox-wrapper">
                {typeOfIssueArr.map((value, i) => (
                  <CheckboxInput
                    name={"typeOfIssue" + i}
                    label={typeOfIssueArr[i]}
                    handleSelect={(name, label, checked) => {
                      if (label === 'Exposed nails') setFieldValue("typeOfIssue0", checked)
                      if (label === 'Broken Boards') setFieldValue("typeOfIssue1", checked)
                      if (label === 'Missing Boards') setFieldValue("typeOfIssue2", checked)
                      if (label === 'Other') setFieldValue("typeOfIssue3", checked)
                      if (props.values.typeOfIssue3 == false) {
                        setOtherState(true);
                      } else {
                        setOtherState(false);
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </RowGroup>
        <RowGroup>
          <div className="row mx-0">
            <div className="col-12">
              <div className="stepUpload">
                <UploadSpecification
                  name="fileUpload"
                  props={props}
                  ProfileName=""
                  CompanyName=""
                  pageType=""
                  fileArr={fileArr}
                  imageLoadCallBack={(imageArr) => {
                    imageLoadCallBack(imageArr)
                  }}
                  callBackFun={(imageArr) => {
                    callBackFun(imageArr);
                  }}
                />
              </div>
            </div>
          </div>
        </RowGroup>
        <RowGroup>
          <div className="row mx-0">
            <div className="col-12">
              <div className="my-2">
                {otherState === true ? (
                  <p className="bold">
                    Discrepancy Details<span className="star">*</span>
                  </p>
                ) : (
                  <p className="bold">Discrepancy Details<span className="star">*</span></p>
                )}
              </div>
              <div>
                <TextArea name="comments" placeholder="" />
              </div>
            </div>
          </div>
        </RowGroup>
      </div>
    );
  }
  const quantityIssue = () => {
    return <div className='pt-3'>
      <RowGroup><div className="row mx-0 marginBottom">
        <div className='col-8'>
          <div className='mb-2'>
            <p className="bold">Total Pallets Missing From Order
              <span className="star">*</span></p>
          </div>
          <div>
            <NumberInput name='totalNumberQuantity' quantityVal={520} placeholder="Enter Number of Pallets Missing" />
          </div>
        </div>
      </div></RowGroup>

      <RowGroup>
        <div className="row mx-0">
          <div className='col-12'>
            <div className='my-2'>
              <p className="bold">Discrepancy Details<span className="star">*</span></p>
            </div>
            <div>
              <TextArea name='comments' placeholder='' />
            </div>
          </div>
        </div>
      </RowGroup>
    </div>
  }
  const bolIssue = () => {
    return <div className='pt-3'>
      <RowGroup>
        <div className="row mx-0">
          <div className='col-12'>
            <div className='my-2'>
              <p className="bold">Discrepancy Details<span className="star">*</span></p>
            </div>
            <div>
              <TextArea name='comments' placeholder='' />
            </div>
          </div>
        </div>
      </RowGroup>
    </div>
  }
  return (
    <div className={styles.Wrapper}>
      <div className={styles.formContainer}>
        <div className={styles.form}>
          <div>
            <div className='mb-3'>
              <h6 style={{ textAlign: 'center', marginBottom: '15px' }} className={styles.headingName}>Claim Details</h6>
            </div>
            <RowGroup>
              <div className="row mx-0">
                <div className='col-6'>
                  <div className='mb-2'>
                    <p className="bold">Order Number</p>
                  </div>
                  <div>
                    <p>{response.orderId}</p>
                  </div>
                </div>
                {response.poNumber && <div className='col-4'>
                  <div className='mb-2'>
                    <p className="bold">PO Number</p>
                  </div>
                  <div>
                    <p>{response.poNumber}</p>
                  </div>
                </div>}
              </div>
            </RowGroup>
            <RowGroup>
              <div className="row mx-0">
                <div className='col-12'>
                  <div className='mb-2'>
                    <p className="bold">Location</p>
                  </div>
                  <div>
                    <p>{response.location.name}&nbsp; {response.location.line1}{response.location.line2}&nbsp;{response.location.city} {stateConvert(response.location.state) || response.location.state}&nbsp;{response.location.zip}</p>
                  </div>
                </div>
              </div>
            </RowGroup>

            <RowGroup>

              <div className="row mx-0">
                <div className='col-4'>
                  <div className='mb-2'>
                    <p className="bold">Material, Condition</p>
                  </div>
                  <div>
                    {response.order && response.order.orderDetails && response.order.orderDetails.material}, {response.order && response.order.orderDetails && response.order.orderDetails.material === 'OTHER' ? 'NA' : response.order && response.order.orderDetails.condition && response.order.orderDetails.condition.length > 0 && response.order.orderDetails.condition[0]}
                    {response.order?.orderDetails?.newConditionType && (response.order?.orderDetails?.newConditionType === "HARDWOOD" ? '(HW)' : '(SW)')}
                  </div>
                </div>

                <div className='col-4'>
                  <div className='mb-2'><p className="bold">Type, Size, Grade</p></div>
                  {getMaterialDetails(response)}
                </div>

                <div className='col-4'>
                  <div className='mb-2'>
                    {/* {response.contactInfo.type} */}
                    {response?.order?.contactInfo?.type === "PICKUP" ? <p className="bold">Pickup Date</p> : <p className="bold">Delivery Date</p>}

                  </div>
                  <div>
                    {moment(response.deliveryDate).format(FORMAT)}
                  </div>
                </div>
              </div>
            </RowGroup>

            <RowGroup>

              <div className="row mx-0">
                <div className='col-4'>
                  <div className='mb-2'>
                    <p className="bold">Quantity</p>
                  </div>
                  <div>
                    {/* {(resolvedWithExchange && exchangeClaimListTotalQuantity > 0) ? <p>{exchangeClaimListTotalQuantity}</p>
                      :
                      (response.quantity ? <p>{response.quantity}</p> : <p>NA</p>)} */}
                    {response.quantity ? <p>{response.quantity}</p> : <p>NA</p>}
                    <p>{ }</p>
                  </div>
                </div>

                <div className='col-4'>
                  <div className='mb-2'>
                    <p className="bold">Unit Cost</p>
                  </div>
                  <div>
                    <p>${response.costPerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                  </div>
                </div>

                <div className='col-4'>
                  <div className='mb-2'>
                    <p className="bold">Total Cost</p>
                  </div>
                  <div>
                    <p>${response.totalCost && response.totalCost?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                  </div>
                </div>
              </div>
            </RowGroup>

            <RowGroup>
              <div className="row mx-0">
                {patternArr &&
                  patternArr.map((value, index) => (
                    <div className='col-6' key={index}>
                      <Field
                        component={RadioButton}
                        name='claimIssue'
                        id={value.value}
                        defaultValue={patternArr[0].value}
                        onSelect={(e) => {
                          setFieldValue('totalNumberQuality', '')
                          setFieldValue('totalNumberQuantity', '')
                          setFieldValue('fileUpload', '')
                          setFieldValue('comments', '')
                          setFieldValue("typeOfIssue0", false)
                          setFieldValue("typeOfIssue1", false)
                          setFieldValue("typeOfIssue2", false)
                          setFieldValue("typeOfIssue3", false)

                          setConditionalState(e.target.value)
                          callBackFun(e.target.value)
                        }}
                        label={value.label}
                      />
                    </div>
                  ))}
              </div>
            </RowGroup>

            {conditionalState === "QUALITY" && qualityIssue('QUALITY')}
            {conditionalState === "QUANTITY" && quantityIssue()}
            {conditionalState === "BOTH" && qualityIssue('BOTH')}
            {conditionalState === "BOL" && bolIssue()}
          </div>
        </div>
      </div>
    </div>
  );
};

const RowGroup = styled.div`
text-align: left;
margin: 10px 0;
.marginBottom{
  margin-bottom: 15px;
}
.bold {
  font-family: "latobold";
  color: #000 !important;
  font-size:17px !important;
}
.quantityIssue {
        font-size: 14px;
  padding: 0 15px;
  color: #ef5657;
}
.checkbox-wrapper {
        display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.TNP {
    .app-input-text {
      margin: 0;
    }
}
.flxWrapper {
    display: flex;
  align-items: center;
  gap: 15px;
  justify-content: space-between;
}
.stepUpload {
    .custom-file-input::before {
        content: "Upload Images/Documents";
    }
    .uploadPhoto {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      > div {
          display: flex;
          align-items: center;
          font-size: 14px;
          border: 2px solid #61b01f;
          padding: 3px 12px;
          border-radius: 20px;
          margin: 10px;
          margin-top:20px;
      }
      svg {
              width: 18px;
              height: 18px;
              margin-left: 5px;
              cursor: pointer;
      }
}
`
